import BreadcrumbLayout from './BreadcrumbLayout';

export default BreadcrumbLayout;
